<template>
    <div class="login">
      <div class="row" style="justify-content: center;background-color: white">
        <div class="col-3"></div>
        <div class="col-6" style="margin-top: 80px">
          <v-row style="justify-content: center">
            <v-img
              alt="TCDC_LOGO"
              class="shrink ml-3"
              contain
              src="@/assets/logo-tcdc.png"
              transition="scale-transition"
              width="200px"
            />
          </v-row>
          <div class="row center">
            <v-col cols="12">
              <input-text-field label="E-mail" :model="email"
                                class="input-width"
                                @update="updateUsername"/>
            </v-col>
          </div>
          <div class="row center">
            <v-col cols="12">
              <input-text-field label="Password" :model="password"
                                class="input-width"
                                inputType="password"
                                @onEnter="onLogin"
                                @update="updatePassword"/>
            </v-col>
          </div>
          <div class="row center">
            <v-col cols="12">
              <submit-button label="Login" width="400px"
                             height="40px"
                             class="input-width"
                             @click.native="onLogin"/>
            </v-col>
          </div>
          <div class="row center">
            <v-col cols="12">
              <login-button width="400px"
                            class="input-width"
                            label="login with google" icon @click.native="googleLogin"
              />
            </v-col>
          </div>
        </div>
        <div class="col-3"></div>
      </div>
    </div>
</template>

<script>
import { mapState, mapActions} from 'vuex';
// eslint-disable-next-line import/extensions
import InputTextField from '../components/Input/InputTextField';
// eslint-disable-next-line import/extensions
import SubmitButton from '../components/Button/SubmitButton';
// eslint-disable-next-line import/extensions
import LoginButton from '../components/Button/LoginButton';
import { url } from '../util/Constants';
import Swal from 'sweetalert';

export default {
  name: 'Login',
  components: { LoginButton, SubmitButton, InputTextField },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.Login.isLogin,
      token: state => state.Login.token,
      userDetail: state => state.Login.userDetail
    }),
  },
  async mounted() {
    console.log('mounted login')
    if (this.$route.query.hasOwnProperty('result')) {
      let param = { token: this.$route.query.result };
      await this.$store.dispatch('Login/onUserLoginWithGoogle',param);
      await this.$store.dispatch('Login/onGetUserDetail', param);
    }
    console.log('login', this.isLogin)
    if(this.isLogin && this.userDetail) {
      this.$router.push('home')
      // window.location = '/home';
    }
  },
  methods: {
    async onLogin() {
      if (!this.email) {
        Swal('','Please insert E-mail','error');
      } else if (!this.password) {
        Swal('','Please insert password','error');
      } else {
        let param = { email: this.email, password : this.password }
        await this.$store.dispatch('Login/onLogin', param).then((res)=>{
           this.$store.dispatch('Login/onGetUserDetail', res).then(()=>{
             this.$router.push('/home')
           });
        }).catch(() => {
          Swal('','อีเมลหรือพาสเวิร์ดไม่ถูกต้อง','error');
        })
      }
    },
    googleLogin() {
      console.log( url + 'saml2/tcdc/login');
      window.location =  url + 'saml2/tcdc/login';
    },
    updateUsername(val) {
      this.email = val;
    },
    updatePassword(val) {
      this.password = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  background-color: white;
  height: 90vh;
  text-align: center;
  justify-content: center;
}
.input-width{
  width: 400px;
  margin-left: calc(35% - 100px);
}
.center{
  justify-content: center
}
</style>
